window.GA4 = window.GA4 || {};
window.GA4.analyticsGa4 = window.GA4.analyticsGa4 || {};

(function (analyticsModules) {
  const PageViewTracker = {
    isInitialized: false,
    init: function () {
      this.pushPageview();
      this.pushHashChange();
    },

    pushPageview: function () {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        var data = {
          event: 'virtualPageview',
          page_location: window.location.href,
          ...baseData,
        };
        if (!baseData.page_title) {
          data.page_title = document.title;
        }
        window.GA4.analyticsGa4.core.sendData(data);
      }
    },

    pushHashChange: function () {
      window.addEventListener('hashchange', this.pushPageview);
    },
  };

  const FilterTracker = {
    pushFilter: function (mainFilter, subFilter, filterOptions) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        var data = {
          event: 'filterEvent',
          main_filter: mainFilter,
        };

        if (subFilter) {
          data.sub_filter = subFilter;
        }

        if (filterOptions) {
          data.filter_options = filterOptions;
        }

        data = { ...data, ...baseData };

        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
  };

  const SearchTracker = {
    pushSearch: function (searchTerm, numberOfResults, numberOFSuggestions, mainFilter, subFilter) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        var data = {
          event: 'site_search',
          search_term: searchTerm,
          search_results: numberOfResults,
        };

        if (numberOFSuggestions) data.search_result_suggestions = numberOFSuggestions;
        if (mainFilter) data.main_filter = mainFilter;
        if (subFilter) data.sub_filter = subFilter;

        data = { ...data, ...baseData };

        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
  };

  const roundNumber = (num, numberDecimalDigit = 2) => {
    if (typeof num !== 'number') {
      return '';
    }

    return +(Math.round(num + ('e+' + numberDecimalDigit)) + ('e-' + numberDecimalDigit));
  };

  const roundNumberCb = (item) => ({ ...item, price: roundNumber(item.price) });

  const getBlockAttr = (el, attrName) => {
    let closest = el.closest(`[${attrName}]`);

    if (!closest) {
      return;
    }

    return closest.getAttribute(attrName);
  };

  const CTATracker = {
    init: function () {
      let mainEl = document.querySelector('main');
      if (!mainEl) return;
      let links = mainEl.querySelectorAll('a');
      const linksAsSpan = mainEl.querySelectorAll('span.arjo-a-link');
      let buttons = mainEl.querySelectorAll('[class*="arjo-a-button"]');

      const extFileDownload = ['doc', 'docm', 'docx', 'pdf', 'pptm', 'pptx', 'psd', 'pst', 'rar', 'xls', 'xlm', 'xlsm', 'xlsx', 'xlt', 'zip'];

      [].forEach.call([...links, ...linksAsSpan], (link) => {
        link.addEventListener('mousedown', (e) => {
          if (e.button === 2) return;
          if (link.classList.contains('arjo-a-button')) return;

          let type = link.getAttribute('data-tracking-type'),
            placement = link.getAttribute('data-tracking-placement'),
            linkText = link.innerText,
            className = link.getAttribute('class'),
            ctaName = link.id || className,
            campaignId = link.getAttribute('data-tracking-campaign'),
            fileName = link?.href && link?.href.split('#').shift().split('?').shift().split('/').pop(),
            dataFileName = link.getAttribute('data-file-name');

          if (className?.includes('arjo-a-link--download-item')) {
            return;
          }

          if (fileName && extFileDownload.some((ext) => fileName.toLocaleLowerCase().endsWith(`.${ext}`))) {
            window.GA4.analyticsGa4.DownloadTracker.pushDownload({ fileName: fileName, name: className, linkText: linkText });
            return;
          }

          if (dataFileName) {
            window.GA4.analyticsGa4.DownloadTracker.pushDownload({ fileName: dataFileName, name: className, linkText: linkText });
            return;
          }

          if (!type) {
            if (link.classList.contains('arjo-a-link--btn')) {
              type = 'Button';
            } else {
              type = 'Clickable link';
            }
          }

          const blockId = getBlockAttr(link, 'data-id');
          const blockName = getBlockAttr(link, 'data-block-name');

          window.GA4.analyticsGa4.CTATracker.pushCTA(type, placement ?? 'CTA block', linkText, ctaName, campaignId, blockId, blockName);
        });
      });

      [].forEach.call(buttons, (button) => {
        button.addEventListener('mousedown', (e) => {
          if (e.button === 2) return;

          let type = 'Button',
            placement = button.getAttribute('data-tracking-placement'),
            linkText = button.innerText,
            ctaName = button.name || button.id || button.getAttribute('class'),
            campaignId = button.getAttribute('data-tracking-campaign');

          const blockId = getBlockAttr(button, 'data-id');
          const blockName = getBlockAttr(button, 'data-block-name');

          window.GA4.analyticsGa4.CTATracker.pushCTA(type, placement ?? 'CTA block', linkText, ctaName, campaignId, blockId, blockName);
        });
      });
    },
    pushCTA: function (ctaType, placement, linkText, ctaName, campaignId, blockId, blockName) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        var data = {
          event: 'ctaEvent',
          type: ctaType,
          placement: placement,
          link_text: linkText,
          name: ctaName,
          ...baseData,
          campaign_id: campaignId,
        };

        if (blockId) data.block_id = blockId;

        if (blockName) data.block_name = blockName;

        if (ctaType === 'Clickable link' && window.GA4.analyticsGa4.core.checkDuplicate(data)) {
          return;
        }
        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
  };

  const DownloadTracker = {
    pushDownload: function ({ isOverlay, linkText, name, fileName }) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        var data = {
          event: 'downloads',
          type: 'download',
          placement: isOverlay ? 'CTA Overlay' : 'CTA Block',
          link_text: linkText,
          name: name,
          asset_title: fileName,
          ...baseData,
        };

        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
  };

  const AuthTracker = {
    pushAuth: function (type, portal) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        var data = {
          event: 'formSubmit',
          type: type,
          portal: portal,
          ...baseData,
        };

        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
  };

  const ViewModelTracker = {
    pushViewModel: function ({ type, name }) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        var data = {
          event: 'view-model',
          type: type,
          ...baseData,
        };

        if (name) data.name = name;

        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
  };

  const EshopTracker = {
    pushAddToCart: function ({ currency = '', items = [], value }) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        const totalPrice = value ?? items.reduce((prev, curr) => prev + curr.price * curr.quantity, 0);

        const ecommerce = {
          currency: currency,
          value: totalPrice ? roundNumber(totalPrice) : 0,
          items: items.map(roundNumberCb),
        };

        var data = {
          event: 'add_to_cart',
          ...baseData,
          ecommerce: ecommerce,
        };

        window.GA4.analyticsGa4.core.sendData({ ecommerce: null });
        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
    pushRemoveFromCart: function ({ currency = '', items = [], value }) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        const totalPrice = value ?? items.reduce((prev, curr) => prev + curr.price * curr.quantity, 0);

        const ecommerce = {
          currency: currency,
          value: totalPrice ? roundNumber(totalPrice) : 0,
          items: items.map(roundNumberCb),
        };

        var data = {
          event: 'remove_from_cart',
          ...baseData,
          ecommerce: ecommerce,
        };

        window.GA4.analyticsGa4.core.sendData({ ecommerce: null });
        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
    pushCheckout: function ({ currency, coupon = '', items = [], value }) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        const totalPrice = value ?? items.reduce((prev, curr) => prev + curr.price * curr.quantity, 0);

        const ecommerce = {
          currency: currency,
          value: totalPrice ? roundNumber(totalPrice) : 0,
          coupon: coupon,
          items: items.map(roundNumberCb),
        };

        var data = {
          event: 'begin_checkout',
          ...baseData,
          ecommerce: ecommerce,
        };

        window.GA4.analyticsGa4.core.sendData({ ecommerce: null });
        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
    pushOrder: function ({ transaction_id, tax = 0, shipping = 0, currency, coupon = '', items = [], value }) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        const totalPrice = value ?? items.reduce((prev, curr) => prev + curr.price * curr.quantity, 0);

        const ecommerce = {
          currency: currency,
          transaction_id: transaction_id,
          tax: roundNumber(tax),
          shipping: shipping,
          coupon: coupon,
          value: totalPrice ? roundNumber(totalPrice) : 0,
          items: items.map(roundNumberCb),
        };

        var data = {
          event: 'purchase',
          ...baseData,
          ecommerce: ecommerce,
        };

        window.GA4.analyticsGa4.core.sendData({ ecommerce: null });
        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
  };

  const SlingTracker = {
    trackExpandCollapseFilter(mainFilter, filterName, isCollapsed) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        const data = {
          event: 'sling_selector_event',
          sling_action: isCollapsed ? 'collapse' : 'expand',
          filter_event: filterName,
          main_filter: mainFilter,
          ...baseData,
        };

        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
    trackFilterChange(mainFilter, collectionName, filterOptions) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        const data = {
          event: 'sling_selector_event',
          sling_action: 'filter',
          sub_filter: `${collectionName}`,
          main_filter: mainFilter,
          filter_options: filterOptions,
          ...baseData,
        };

        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
    trackProductClick(mainFilter, productName, collectionName, filterOptions) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        const data = {
          event: 'sling_selector_event',
          sling_action: 'product_click',
          product_name: productName,
          sub_filter: collectionName,
          main_filter: mainFilter,
          filter_options: filterOptions,
          ...baseData,
        };

        window.GA4.analyticsGa4.core.sendData(data);
      }
    },

    trackAssetClick(mainFilter, assetName, assetUrl, collectionName, filterOptions) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        const data = {
          event: 'sling_selector_event',
          sling_action: 'asset_click',
          asset_name: assetName,
          assert_url: assetUrl,
          sub_filter: collectionName,
          main_filter: mainFilter,
          filter_options: filterOptions,
          ...baseData,
        };

        window.GA4.analyticsGa4.core.sendData(data);
      }
    },

    trackVideoClick(mainFilter, videoId, collectionName, filterOptions) {
      const baseData = window.GA4.analyticsGa4.core.getBaseObject();

      if (window.dataLayer) {
        const data = {
          event: 'sling_selector_event',
          sling_action: 'video_click',
          video_id: videoId,
          sub_filter: collectionName,
          main_filter: mainFilter,
          filter_options: filterOptions,
          ...baseData,
        };

        window.GA4.analyticsGa4.core.sendData(data);
      }
    },
  };

  analyticsModules.PageViewTracker = PageViewTracker;
  analyticsModules.FilterTracker = FilterTracker;
  analyticsModules.SearchTracker = SearchTracker;
  analyticsModules.CTATracker = CTATracker;
  analyticsModules.DownloadTracker = DownloadTracker;
  analyticsModules.AuthTracker = AuthTracker;
  analyticsModules.ViewModelTracker = ViewModelTracker;
  analyticsModules.EshopTracker = EshopTracker;
  analyticsModules.SlingTracker = SlingTracker;

  let interval;
  interval = setInterval(() => {
    if (!analyticsModules.PageViewTracker.isInitialized && typeof window.dataLayer !== 'undefined') {
      PageViewTracker.init();
      CTATracker.init();
      analyticsModules.PageViewTracker.isInitialized = true;
      clearInterval(interval);
    }
  }, 200);
})(window.GA4.analyticsGa4);
